// src/context/AuthContext.js
import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import api from "../api/axios";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]   = useState(() => {
    try { return JSON.parse(localStorage.getItem("astro_user")); } catch { return null; }
  });
  const [token, setToken] = useState(() => localStorage.getItem("astro_token"));

  // Listen for storage changes (e.g. admin updates own profile)
  useEffect(() => {
    const handleStorage = () => {
      try {
        const u = JSON.parse(localStorage.getItem("astro_user"));
        if (u) setUser(u);
      } catch {}
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login.php", { email, password });
    localStorage.setItem("astro_token", data.token);
    localStorage.setItem("astro_user",  JSON.stringify(data.user));
    setToken(data.token);
    setUser(data.user);
    return data;
  }, []);

  const register = useCallback(async (name, email, password) => {
    const { data } = await api.post("/auth/register.php", { name, email, password });
    localStorage.setItem("astro_token", data.token);
    localStorage.setItem("astro_user",  JSON.stringify(data.user));
    setToken(data.token);
    setUser(data.user);
    return data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("astro_token");
    localStorage.removeItem("astro_user");
    setToken(null);
    setUser(null);
  }, []);

  // Refresh user from localStorage (called after profile update)
  const refreshUser = useCallback(() => {
    try {
      const u = JSON.parse(localStorage.getItem("astro_user"));
      if (u) setUser(u);
    } catch {}
  }, []);

  return (
    <AuthContext.Provider value={{
      user, token, login, register, logout, refreshUser,
      isAdmin: user?.role === "admin"
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
